export const FEATURED_ITEM_COUNT = 4;

export const SITE_HOST = 'hinterland.software';

// Contentful locales are static for this space; keeping them here saves a
// network round trip before anything can render.
export const LOCALES = [
  { code: 'en-US', name: 'English', default: true },
  { code: 'de', name: 'Deutsch', default: false },
];

export const GTM_ID = 'GTM-NLJQ2ZDQ';

// The two legal pages, their public slug per language and the microcopy keys
// that hold them. The rewrites in vercel.json mirror the slugs.
export const LEGAL_PAGES = {
  impressum: {
    slug: { en: '/legal-notice', de: '/impressum' },
    titleKey: 'legal.impressum.title',
    contentKey: 'legal.impressum.content',
  },
  datenschutz: {
    slug: { en: '/privacy', de: '/datenschutz' },
    titleKey: 'legal.datenschutz.title',
    contentKey: 'legal.datenschutz.content',
  },
};

export const COOKIE_SETTINGS_LABEL = {
  en: 'Cookie settings',
  de: 'Cookie-Einstellungen',
};

/** Maps any known legal path or prerendered file name to its page key. */
export const legalPageFromPath = (pathname) => {
  const clean = pathname.replace(/^\//, '').replace(/\/$/, '');
  const file = clean.match(/^legal\.(impressum|datenschutz)\.(?:en|de)\.html$/);
  if (file) return file[1];
  for (const [page, { slug }] of Object.entries(LEGAL_PAGES)) {
    if (Object.values(slug).includes(`/${clean}`)) return page;
  }
  return null;
};
